interface DataErrorProps {
  title: string;
  subtitle: React.ReactNode;
  icon: React.ReactNode;
}

/**
 * Reflects that artist data can't be shown, regardless of the reason.
 */
export function DataError({
  title,
  subtitle,
  icon,
}: DataErrorProps): React.ReactNode {
  return (
    <div className="mt-md flex w-full flex-col items-center justify-center gap-lg rounded-sm py-5xl tracking-wider outline-dashed outline-1 outline-offset-[-1px] bg-level-01 outline-emphasis-subtle">
      <span className="flex shrink-0 items-center justify-center">{icon}</span>
      <div className="flex w-full flex-col items-center justify-center gap-sm">
        <div className="text-body-lg font-semibold text-white">{title}</div>
        <div className="text-body-md font-normal text-subtle">{subtitle}</div>
      </div>
    </div>
  );
}
DataError.displayName = 'DataError';
